import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { delay, getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const fakeQmsDocuments = [
  {
    qmsDocumentId: 1,
    qmsDocumentTypeId: 1,
    divisionId: 1,
    title: "Title of This BCM",
    number: "BCM 1-1.01",
    description: "Some Description of BCM",
    lastRevisedOn: new Date("10/31/2022").toISOString(),
  },
  {
    qmsDocumentId: 2,
    qmsDocumentTypeId: 2,
    divisionId: 1,
    title: "Sample BCM",
    number: "BCM F-1",
    description: "Some Description of BCM",
    lastRevisedOn: new Date("10/31/2022").toISOString(),
  },
];

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const qmsDocumentActions = {
  add: (newDocumentData, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTS.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocument";
    try {
      const res = await axios.post(apiEndpoint, newDocumentData);
      dispatch({
        type: QMS.DOCUMENTS.ADD_FULFILLED,
        divisionId,
        qmsDocuments: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTS.ADD_REJECTED });
      logError(e);
    }
  },
  update: (qmsDocumentData, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTS.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocument";
    try {
      const res = await axios.put(apiEndpoint, qmsDocumentData);
      dispatch({
        type: QMS.DOCUMENTS.UPDATE_FULFILLED,
        divisionId,
        qmsDocuments: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTS.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (qmsDocumentId, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTS.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocument/" + qmsDocumentId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({
        type: QMS.DOCUMENTS.REMOVE_FULFILLED,
        qmsDocuments: res.data,
        divisionId,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTS.REMOVE_REJECTED });
      logError(e);
    }
  },
  removeRange: (qmsDocumentIds, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTS.REMOVE });
    const apiEndpoint_delete = `${BASE_URL}/api/qms/QmsDocument`;
    try {
      const delRes = await axios.delete(apiEndpoint_delete, {
        params: { ids: qmsDocumentIds || [] },
        paramsSerializer: (params) => qs.stringify(params),
      });
      if (delRes.data.message) {
        dispatch({ type: QMS.DOCUMENTS.REMOVE_REJECTED });
        // Show alert
        alert(delRes.data.message);
      } else {
        const apiEndpoint_getAll = BASE_URL + "/api/qms/QmsDocument/List/" + divisionId;
        const res = await axios.get(apiEndpoint_getAll);
        dispatch({
          type: QMS.DOCUMENTS.REMOVE_FULFILLED,
          divisionId,
          qmsDocuments: res.data,
        });
      }
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTS.REMOVE_REJECTED });
      logError(e);
    }
  },
  get: (qmsDocumentId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTS.FETCH });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocument/" + qmsDocumentId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.DOCUMENTS.FETCH_FULFILLED, qmsDocument: res.data });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTS.FETCH_REJECTED });
      logError(e);
    }
  },
  getAllFake: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTS.FETCH_ALL });

    delay(850);
    dispatch({
      type: QMS.DOCUMENTS.FETCH_ALL_FULFILLED,
      qmsDocuments: fakeQmsDocuments,
      divisionId,
    });
  },
  getAll: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTS.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocument/List/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.DOCUMENTS.FETCH_ALL_FULFILLED,
        qmsDocuments: res.data,
        divisionId,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTS.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
  downloadFile: (qmsDocumentId, filename) => async (dispatch) => {
    dispatch({ type: QMS.FILE_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocument/File/" + qmsDocumentId;
    try {
      const res = await axios.get(apiEndpoint, {
        responseType: "blob",
      });
      if (res.data) {
        const fileBlob = new Blob([res.data]);

        const url = URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        dispatch({ type: QMS.FILE_REQUEST_FULFILLED });
      }
      return;
    } catch (err) {
      dispatch({ type: QMS.FILE_REQUEST_REJECTED });
      logError(err);
    }
  },
};

export default qmsDocumentActions;
